export default __webpack_public_path__ + "00f793f8c41eb10c2f449d695ea4bd1f.png";